$('.js-tab-section').each(function() {
    const $section = $(this);
    const $navLinks = $section.find('.js-tab-nav');
    const $contents = $section.find('.js-tab-content');
    const $fixedImage = $section.find('.services-tabs__fixed-image-inner img');
    let currentSrc = $section.find('.services-tab-content__image > img').attr('src') || '';
    const offsetTrigger = 650;

    $navLinks.click(function(e) {
        e.preventDefault();

        const aid = $(this).data('id');
        const $element = $contents.filter(`[data-id="${aid}"]`);
        const scrollPosition = $element.offset().top - 78;

        $('html, body').animate({ scrollTop: scrollPosition }, 500);
    });

    $(window).on('scroll', function() {
        $contents.each(function() {
            const $box = $(this);
            const boxTop = $box[0].getBoundingClientRect().top;

            if (boxTop <= offsetTrigger && boxTop + $box.outerHeight() > offsetTrigger) {
                $box.addClass('isActive');

                $navLinks.removeClass('isActive');
                $navLinks.filter(`[data-id="${$box.data('id')}"]`).addClass('isActive');

                const activeImage = $box.find('.services-tab-content__image > img');
                if (activeImage.length) {
                    const imageSrc = activeImage.attr('src');

                    if (imageSrc !== currentSrc) {
                        currentSrc = imageSrc;

                        // $fixedImage.css('transition', 'opacity 0.5s ease-in-out');
                        // $fixedImage.css('opacity', 0);
                        //
                        // setTimeout(() => {
                        //     $fixedImage.attr('src', imageSrc);
                        //
                        //     // $fixedImage.on('load', function() {
                        //     //     $fixedImage.css('opacity', 1);
                        //     // });
                        // }, 500);
                    }
                }
            } else {
                $box.removeClass('isActive');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.tabs__inner--ssp');
    if (!section) return;

    const navItems = section.querySelectorAll('.js-tab-nav');
    const contents = section.querySelectorAll('.js-tab-content');
    if (!navItems.length || !contents.length) return;

    const offset = 120; // header height

    // CLICK -> SCROLL
    navItems.forEach(nav => {
        nav.addEventListener('click', () => {
            const id = nav.dataset.tab;
            const target = section.querySelector('.js-tab-content[data-tab="' + id + '"]');
            if (!target) return;

            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: 'smooth' });
        });
    });

    // SCROLL -> ACTIVE TAB
    window.addEventListener('scroll', () => {
        let current = null;

        contents.forEach(content => {
            const rect = content.getBoundingClientRect();
            if (rect.top <= offset + 10 && rect.bottom > offset + 10) {
                current = content.dataset.tab;
            }
        });

        if (!current) return;

        navItems.forEach(nav => {
            nav.classList.toggle('isActive', nav.dataset.tab === current);
        });

        contents.forEach(c => {
            c.classList.toggle('isActive', c.dataset.tab === current);
        });
    });
});

const initMobTabsScrollSpy = () => {
    const navWraps = document.querySelectorAll('.js-mob-tabs-nav-wrap');
    if (!navWraps.length) return;

    const header = document.querySelector('.js-header');

    navWraps.forEach(wrap => {
        const navContainer = wrap.querySelector('.js-mob-tabs-nav');
        const links = wrap.querySelectorAll('.js-mob-tab-link');
        const contentContainer = wrap.nextElementSibling;
        if (!contentContainer) return;
        
        const sections = contentContainer.querySelectorAll('.js-mob-tab-section');
        const parent = wrap.parentElement; // .tabs__inner--mobile
        
        parent.style.position = 'relative';

        const onScroll = () => {
            if (window.innerWidth > 1199) {
                wrap.style.position = '';
                wrap.style.top = '';
                wrap.style.bottom = '';
                wrap.style.left = '';
                wrap.style.width = '';
                wrap.style.zIndex = '';
                contentContainer.style.paddingTop = '';
                return;
            }

            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            const wrapHeight = wrap.offsetHeight;
            const parentRect = parent.getBoundingClientRect();
            
            if (parentRect.top <= headerHeight) {
                if (parentRect.bottom >= headerHeight + wrapHeight) {
                    wrap.style.position = 'fixed';
                    wrap.style.top = `${headerHeight}px`;
                    wrap.style.bottom = 'auto';
                    wrap.style.left = '0';
                    wrap.style.width = '100%';
                    wrap.style.zIndex = '50';
                    contentContainer.style.paddingTop = `${wrapHeight}px`;
                } else {
                    wrap.style.position = 'absolute';
                    wrap.style.top = 'auto';
                    wrap.style.bottom = '0';
                    wrap.style.left = '0';
                    wrap.style.width = '100%';
                    wrap.style.zIndex = '50';
                    contentContainer.style.paddingTop = `${wrapHeight}px`; 
                }
            } else {
                wrap.style.position = 'relative';
                wrap.style.top = 'auto';
                wrap.style.bottom = 'auto';
                wrap.style.left = 'auto';
                wrap.style.width = 'auto';
                wrap.style.zIndex = '1';
                contentContainer.style.paddingTop = '0px';
            }

            const triggerPoint = headerHeight + wrapHeight + 5; 
            let currentActiveId = null;

            sections.forEach(section => {
                const rect = section.getBoundingClientRect();
                if (rect.top <= triggerPoint && rect.bottom > triggerPoint) {
                    currentActiveId = section.id;
                }
            });

            if (currentActiveId) {
                const activeLink = wrap.querySelector(`[data-target="${currentActiveId}"]`);
                if (activeLink && !activeLink.classList.contains('is-active')) {
                    links.forEach(l => l.classList.remove('is-active'));
                    activeLink.classList.add('is-active');

                    const linkRect = activeLink.getBoundingClientRect();
                    const containerRect = navContainer.getBoundingClientRect();
                    const scrollPos = activeLink.offsetLeft - (containerRect.width / 2) + (linkRect.width / 2);
                    
                    navContainer.scrollTo({
                        left: scrollPos,
                        behavior: 'smooth'
                    });
                }
            }
        };

        links.forEach(link => {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                if (window.innerWidth > 1199) return;

                const targetId = link.getAttribute('data-target');
                const targetSection = document.getElementById(targetId);

                if (targetSection) {
                    const headerHeight = header ? header.getBoundingClientRect().height : 0;
                    const wrapHeight = wrap.offsetHeight;
                    const totalOffset = headerHeight + wrapHeight;
                    
                    const sectionTop = targetSection.getBoundingClientRect().top + window.pageYOffset;
                    
                    window.scrollTo({
                        top: sectionTop - totalOffset + 1, 
                        behavior: 'smooth'
                    });
                }
            });
        });

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        
        setTimeout(onScroll, 50);
    });
};

document.addEventListener('DOMContentLoaded', initMobTabsScrollSpy);

document.querySelectorAll('.posts-grid-filters').forEach(filter => {
    if (window.innerWidth > 1199) return;

    const list = filter.querySelector('.posts-grid-filters__list');
    if (!list) return;

    const active = list.querySelector('.active');

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'posts-grid-filters__toggle js-filter-toggle';

    toggle.innerHTML = `
        <span class="posts-grid-filters__label">
            ${filter.querySelector('.posts-grid-filters__label span')?.textContent ?? ''}
        </span>

        <span class="posts-grid-filters__current">
            ${active?.textContent ?? ''}
        </span>

        <span class="posts-grid-filters__arrow"></span>
    `;

    filter.prepend(toggle);

    toggle.addEventListener('click', () => {
        filter.classList.toggle('is-open');
    });

    list.querySelectorAll('button').forEach(btn => {
        btn.addEventListener('click', () => {
            toggle.querySelector('.posts-grid-filters__current').textContent = btn.textContent;

            filter.classList.remove('is-open');
        });
    });

    document.addEventListener('click', e => {
        if (!filter.contains(e.target)) {
            filter.classList.remove('is-open');
        }
    });
});